<yes-no
  *ngIf="!hideNeedAppointment"
  [title]="'Afspraak nodig?'"
  [neverShowExtraInstructions]="true"
  [value]="projectPlacement.appointment"
  [nullIsFalse]="nullIsFalse"
  [nullable]="!nullIsFalse"
  [flexRow]="flexRow"
  [disabled]="disabled"
  [client]="client"
  (answer)="appointmentChange($event)"
></yes-no>

<div class="appointment-sub-block">
  <div
    *ngIf="projectPlacement.appointment"
    [ngClass]="hideNeedAppointment ? 'upper-space' : 'double-less-upper-space'"
  >
    <div [class.align-with-radio-button]="hideNeedAppointment">
      <yes-no
        [yesValue]="'Met makelaar'"
        [noValue]="'Met eigenaar/bewoner'"
        [neverShowExtraInstructions]="true"
        [value]="projectPlacement.appointmentWithCustomer"
        [nullIsFalse]="false"
        [nullable]="true"
        [flexRow]="flexRow"
        [disabled]="disabled"
        [client]="client"
        (answer)="appointmentWithCustomerChange($event)"
      ></yes-no>
    </div>
  </div>

  <div *ngIf="projectPlacement.appointment" class="content-container">
    <ng-container *ngIf="projectPlacement.appointmentWithCustomer">
      <div class="d-flex customer-input-list">
        <mat-form-field appearance="outline" class="selector-right-margin">
          <mat-label>Contactpersoon</mat-label>
          <mat-select
            matInput
            placeholder="Selecteer contact"
            [disabled]="disabled"
            [compareWith]="compareEntities"
            [(ngModel)]="projectPlacement.appointmentContact"
            (ngModelChange)="appointmentContactChange()"
          >
            <mat-option
              *ngFor="let option of contactChoices; trackBy: trackById"
              [value]="option"
            >
              {{ option.firstName | personName : option.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="form-field" appearance="outline">
          <mat-label>Telefoonnummer Contact</mat-label>
          <input
            matInput
            placeholder="Telefoonnummer"
            value="{{
              projectPlacement.appointmentContact?.phoneNumberDisplay
            }}"
            disabled
          />
          <a
            matSuffix
            class="click-phone"
            href="tel:{{
              projectPlacement.appointmentContact?.phoneNumberDisplay
            }}"
          >
            <mat-icon class="scale-icon">call</mat-icon>
          </a>
        </mat-form-field>

        <mat-form-field class="form-field" appearance="outline">
          <mat-label>GSM-nummer Contact</mat-label>
          <input
            matInput
            placeholder="Telefoonnummer"
            value="{{
              projectPlacement.appointmentContact?.mobileNumberDisplay
            }}"
            disabled
          />
          <a
            matSuffix
            class="click-phone"
            href="tel:{{
              projectPlacement.appointmentContact?.mobileNumberDisplay
            }}"
          >
            <mat-icon class="scale-icon">call</mat-icon>
          </a>
        </mat-form-field>
        <mat-form-field class="last-form-field form-field" appearance="outline">
          <mat-label>E-mailadres</mat-label>
          <input
            matInput
            placeholder="E-mailadres"
            value="{{ projectPlacement.appointmentContact?.emailDisplay }}"
            disabled
          />
        </mat-form-field>
      </div>
    </ng-container>

    <ng-container *ngIf="projectPlacement.appointmentWithCustomer === false">
      <div class="owner-form-field-container">
        <mat-form-field appearance="outline">
          <mat-label>Naam</mat-label>
          <input
            matInput
            [(ngModel)]="projectPlacement.appointmentName"
            (ngModelChange)="appointmentNameChange()"
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Tel. / GSM</mat-label>
          <input
            matInput
            [ngModel]="
              projectPlacement.appointmentPhoneNumber | asFormatPhoneNumber
            "
            (ngModelChange)="appointmentPhoneNumberChange($event)"
          />
          <a
            matSuffix
            class="click-phone"
            href="tel:{{ projectPlacement.appointmentPhoneNumber }}"
          >
            <mat-icon class="scale-icon">call</mat-icon>
          </a>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>E-mail</mat-label>
          <input
            matInput
            [(ngModel)]="projectPlacement.appointmentEmail"
            (ngModelChange)="appointmentEmailChange()"
          />
        </mat-form-field>
      </div>
    </ng-container>

    <textarea-input
      *ngIf="!hideNeedAppointmentInfo"
      [initContent]="projectPlacement.needAppointmentInfo"
      [placeholder]="'Extra info omtrent de afspraak'"
      [client]="client"
      [disabled]="disabled"
      [sensitive]="true"
      (answer)="needAppointmentInfoChange($event)"
    ></textarea-input>
  </div>
</div>
